export function friendlyStaffError(error: unknown, fallback: string): string {
	if (error instanceof TypeError) {
		return 'Connection lost. Refresh the page, sign in again if prompted, and try again.';
	}
	return error instanceof Error && error.message ? error.message : fallback;
}
